module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABsAAAAbCAYAAACN1PRVAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAC4SURBVHgB7ZTRDcIgFEUvxAEcoW5A2wXcQN2go+gGbNA4gSPoBrCBjuAE4MVGP2zTr8eHKSchkEfybkIODygUZlC/hbqur0qpLYQIIWy89w8UstE0TZcWMqAnahVX37btxRhTIXPYmxjjXmt9Z2jP0DUEWM1dMvBGdc9U94mMYan5yTlnkRMzIPJsy2E0G/nHLMXYQQj2OlAwn84jQWjfkZukGCImF75MCdJhmI8i0AH7mUAahX/jBTGtO0PJCXgIAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/tree.png
// module id = TIDo
// module chunks = 1